import '../styles.css';

import MembersCard from '../components/MembersCard.jsx';
import { MembersData } from '../data/MembersData.jsx';

import Subheader from '../components/Subheader.jsx';

function MembersPage() {
	return (
		<div>
			<Subheader text="Meet the Team" />

			<div className="membersPage-cardGrid">
				{MembersData.map((item) => (
					<MembersCard data={item} />
				))}
			</div>
		</div>
	);
}

export default MembersPage;
